import {styled} from '../theme-provider';

export const RadioGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
